/**
 * @generated SignedSource<<cc43b310bfeb98fe57b6af71c560fef1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type originalEstimate_nativeIssueTable_OriginalEstimateTimeTrackingFieldCell_fieldRef$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "originalEstimate_nativeIssueTable_OriginalEstimateTimeTrackingFieldCell_fieldRef";
};
export type originalEstimate_nativeIssueTable_OriginalEstimateTimeTrackingFieldCell_fieldRef$key = {
  readonly " $data"?: originalEstimate_nativeIssueTable_OriginalEstimateTimeTrackingFieldCell_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"originalEstimate_nativeIssueTable_OriginalEstimateTimeTrackingFieldCell_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "originalEstimate_nativeIssueTable_OriginalEstimateTimeTrackingFieldCell_fieldRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
    }
  ],
  "type": "JiraTimeTrackingField"
};

(node as any).hash = "312db87c0c11a408da53829b2a0390aa";

export default node;
